import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { FooterComponent } from '../../components/footer.component/footer.component';
import { NavComponent } from '../../components/nav.component/nav.component';

interface FAQ {
  question: string;
  answer: string;
}

@Component({
  selector: 'app-support.component',
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    NavComponent,
    FooterComponent,
  ],
  templateUrl: './support.component.html',
  styleUrl: './support.component.scss',
})
export class SupportComponent {
  // Index of the FAQ that's currently expanded. -1 means none. Defaults
  // to 0 so the first question is open on page load (subtle hint that
  // the accordion is interactive).
  openFaq = 0;

  toggleFaq(index: number): void {
    this.openFaq = this.openFaq === index ? -1 : index;
  }

  // Honest FAQs — only behavior the app actually has today. Anything
  // speculative (token rewards, check-ins, leaderboards) was pulled out.
  faqs: FAQ[] = [
    {
      question: 'How do I find bathrooms near me?',
      answer:
        'Open the app and allow location permissions. The map will center on you and show nearby verified bathrooms color-coded by rating.',
    },
    {
      question: 'How do I save a place I like?',
      answer:
        'Tap a bathroom to open its details, then tap the heart icon. Saved places live in your Favorites tab and stay synced to your account.',
    },
    {
      question: 'How do reviews work?',
      answer:
        'Tap any place on the map and choose Rate this restroom. You can leave an overall rating, attribute details (cleanliness, accessibility, hours, and more), and an optional comment.',
    },
    {
      question: 'Is my location data private?',
      answer:
        'Yes. Your location is only used while you are searching, and we never sell your data. Read more on our Privacy page.',
    },
    {
      question: 'The app crashed. What should I do?',
      answer:
        'Try fully closing and reopening the app first. If it keeps happening, reach out using the contact form below and let us know what you were doing when it crashed — that helps us reproduce and fix it quickly.',
    },
    {
      question: 'How do I delete my account?',
      answer:
        'Reach out to us at support@stml.app from the email associated with your account and we will process your deletion request. Account deletion is not yet self-serve in the app — for now a member of our team handles it manually so we can confirm it is really you.',
    },
  ];
}
